import { For } from 'solid-js';
import { manufacturers } from '~/data/categories';
import './Manufacturers.css';

export function Manufacturers() {
  const doubled = [...manufacturers, ...manufacturers];

  return (
    <section class="section section--tight manufacturers" id="about">
      <div class="container">
        <div class="section-head" data-reveal>
          <div class="eyebrow">Парк техники</div>
          <h2>Работаем с&nbsp;грузовой и&nbsp;спецтехникой по&nbsp;всему миру</h2>
          <p class="section-head__lead">
            Помогаем найти двигатели, коробки передач, мосты и редкие запчасти как для распространённых моделей,
            так и для техники, комплектующие к которой сложно приобрести в России.
          </p>
        </div>
      </div>

      <div class="manufacturers__marquee" aria-label="Производители техники" data-reveal>
        <ul class="manufacturers__track" aria-hidden="false">
          <For each={doubled}>
            {(name) => <li class="manufacturers__item">{name}</li>}
          </For>
        </ul>
      </div>
    </section>
  );
}
